import React from "react";
import { CURRENTLY, PAST_LIFE, PROFILE, PROJECTS, SKILL_GROUPS } from "../data";

/**
 * The desktop UI is highly interactive, so the same content is also rendered
 * as plain semantic markup for crawlers and screen readers.
 */
export default function SeoContent() {
  return (
    <div className="sr-only">
      <h1>
        {PROFILE.name} — {PROFILE.role} ({PROFILE.handle})
      </h1>
      <p>{PROFILE.bio}</p>
      <p>
        Based in {PROFILE.location}. Contact:{" "}
        <a href={`mailto:${PROFILE.email}`}>{PROFILE.email}</a>,{" "}
        <a href={PROFILE.phoneHref}>{PROFILE.phone}</a>.
      </p>

      <h2>Currently</h2>
      <ul>
        {CURRENTLY.map((item) => (
          <li key={item.id}>
            <strong>{item.title}</strong> — {item.meta}. {item.description}
          </li>
        ))}
      </ul>

      <h2>Experience</h2>
      <ul>
        {PAST_LIFE.map((item) => (
          <li key={item.id}>
            <strong>{item.title}</strong> — {item.meta}. {item.description}
          </li>
        ))}
      </ul>

      <h2>Skills</h2>
      <ul>
        {SKILL_GROUPS.map((group) => (
          <li key={group.label}>
            {group.label}: {group.items.join(", ")}
          </li>
        ))}
      </ul>

      <h2>Projects</h2>
      <ul>
        {PROJECTS.map((p) => (
          <li key={p.id}>
            <a href={p.url} rel="noopener noreferrer">
              {p.title}
            </a>{" "}
            — {p.description}
          </li>
        ))}
      </ul>
    </div>
  );
}
